import { type EditorPlugin } from '@aha-app/aha-editor-v2';
import BlockedReportComponent from './components/BlockedReportComponent';

const BlockedEmbeddedReportComponentPlugin: EditorPlugin = {
  name: 'Blocked embedded report component',
  components: [
    {
      type: 'embedded-report',
      component: BlockedReportComponent,
    },
    {
      type: 'embedded-report-placeholder',
      component: BlockedReportComponent,
    },
  ],
};

export default BlockedEmbeddedReportComponentPlugin;
